import api from './api';

class NewsService {
  all(page = 1) {
    return api.get(`/api/v1/news/?page=${page}`).then((res) => {
      return res.data;
    });
  }
  show(id: string) {
    return api.get(`/api/v1/news/${id}/`).then((res) => {
      return res.data;
    });
  }
  getSubscribers() {
    return api.get(`/api/v1/counter`).then((res) => {
      return res.data;
    });
  }
}

export default new NewsService();
